import { createSlice } from '@reduxjs/toolkit';
import * as Api from '../Api';

export const templateSlice = createSlice({
  name: 'template',
  initialState: {
    newTemplateIdResponse: '',
    createTemplateResponse: [],
    typesResponse: [],
    customerIDResponse: [],
    allTemplates: [],
    fetchtemplateAttributes: [],
    toggleActiveResponse: [],
    toggleZipPreferenceResponse: [],
    updateResponse: [],
  },
  reducers: {
    setNewTemplateIdResponse: (state, action) => {
      state.newTemplateIdResponse = action.payload;
    },
    setCreateTemplateResponse: (state, action) => {
      state.createTemplateResponse = action.payload;
    },
    setTypes: (state, action) => {
      state.typesResponse = action.payload;
    },
    setcustomerIDResponse: (state, action) => {
      state.customerIDResponse = action.payload;
    },
    getalltemplates: (state, action) => {
      state.allTemplates = action.payload;
    },
    getTemplateAttributes: (state, action) => {
      state.fetchtemplateAttributes = action.payload;
    },
    setToggleResponse: (state, action) => {
      state.toggleActiveResponse = action.payload;
    },
    setToggleZipPreferenceResponse: (state, action) => {
      state.toggleZipPreferenceResponse = action.payload;
    },
    setUpdateResponse: (state, action) => {
      state.updateResponse = action.payload;
    },
  },
});

export function createTemplateId(templateDetails) {
  return async (dispatch) => {
    var response = await Api.postRequest('/template/', 'POST', templateDetails);
    dispatch(setNewTemplateIdResponse(response.id));
  };
}

export function getTemplateTypes() {
  return async (dispatch) => {
    var response = await Api.getRequest('/type/', 'GET');
    dispatch(setTypes(response));
  };
}

export function getCustomerID() {
  return async (dispatch) => {
    var response = await Api.getRequest('/customer/', 'GET');
    dispatch(setcustomerIDResponse(response));
  };
}

export function gettemplates() {
  return async (dispatch) => {
    var response = await Api.getRequest('/template/', 'GET');
    dispatch(getalltemplates(response));
  };
}

export function addTemplate(templateDetails) {
  return async (dispatch) => {
    var response = await Api.postRequest('/templateattribute/multiple/', 'POST', templateDetails);
    dispatch(setCreateTemplateResponse(response));
  };
}

export function setTemplateAttributes(templateID) {
  return async (dispatch) => {
    var response = await Api.getRequest(
      '/templateattribute/fortemplate?templateId=' + templateID,
      'GET',
    );
    dispatch(getTemplateAttributes(response));
  };
}

export function toggleActive(templateID) {
  return async (dispatch) => {
    var response = await Api.postRequest('/template/toggleactive/' + templateID, 'POST', {});
    dispatch(setToggleResponse(response));
  };
}

export function toggleZipPreference(templateId) {
  return async (dispatch) => {
    var response = await Api.postRequest(
      '/template/toggleexactzipsearch/' + templateId,
      'POST',
      {},
    );
    dispatch(setToggleZipPreferenceResponse(response));
  };
}

export function updateTemplate(details) {
  return async (dispatch) => {
    var response = await Api.postRequest('/templateattribute/multiple/', 'PATCH', details);
    dispatch(setUpdateResponse(response));
  };
}

export function resetTemplateStates() {
  return async (dispatch) => {
    dispatch(setNewTemplateIdResponse(''));
    dispatch(setCreateTemplateResponse([]));
    dispatch(setToggleResponse([]));
    dispatch(setToggleZipPreferenceResponse([]));
    dispatch(setUpdateResponse([]));
  };
}

export const {
  setNewTemplateIdResponse,
  setCreateTemplateResponse,
  setTypes,
  setcustomerIDResponse,
  setToggleResponse,
  setToggleZipPreferenceResponse,
  getalltemplates,
  getTemplateAttributes,
  setUpdateResponse,
} = templateSlice.actions;
export const setNewTemplateIdSelector = (state) => state.template.newTemplateIdResponse;
export const setCreateTemplateSelector = (state) => state.template.createTemplateResponse;
export const setTypeSelector = (state) => state.template.typesResponse;
export const setCustomerIDSelector = (state) => state.template.customerIDResponse;
export const setalltemplatesSelector = (state) => state.template.allTemplates;
export const setAttributeSelector = (state) => state.template.fetchtemplateAttributes;
export const setActiveToggleSelector = (state) => state.template.toggleActiveResponse;
export const setZipPreferenceSelector = (state) => state.template.toggleZipPreferenceResponse;
export const setUpdateSelector = (state) => state.template.updateResponse;

export default templateSlice.reducer;
